<template>
  <Form>
    <div class="text-center py-5 px-5">
      <h4>Seja bem-vindo(a)</h4>
    </div>

    <template v-if="!otpRequested">
      <div class="input-group pt-3 pb-3">
        <span class="input-group-text" id="emailHelp"><UserIcon/></span>
        <input v-model="email" placeholder="Seu e-mail" type="email"
               autocomplete="new-password" ref="email"
               @keypress.enter="login()"
               class="form-control input" id="exampleInputEmail1" aria-describedby="emailHelp"/>
      </div>
      <div class="input-group">
        <span class="input-group-text" id="passwordHelp"><LockIcon/></span>
        <input v-model="password" placeholder="Sua senha"
               :type="showPassword ? 'text' : 'password'"
               @keypress.enter="login()"
               class="form-control input"
               autocomplete="new-password"
               id="exampleInputPassword1" aria-describedby="passwordHelp"/>
        <i class="eye-password" @click="showPassword = !showPassword" :title=" showPassword ? 'Ocultar Senha' : 'Mostrar Senha' ">
          <EyeIcon v-if="showPassword" />
          <EyeOffIcon v-else/>
        </i>
      </div>

      <div class="input-group mt-2 d-flex flex-row justify-content-end">
        <small>
          <a class="forgot-password" href="forgot_password" @click.prevent="sendForgetPassword">
            Esqueci minha senha</a>
        </small>
      </div>

      <div class="form-group pb-5">
        <div class="row">
          <div id="sign-in" class="btn-group col-md-12 mt-3">
            <button @click="login" :disabled="disableLoginButton" class="btn btn-primary">Entrar</button>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="text-center pb-3">
        <small class="text-muted">Código de verificação enviado para seu email</small>
      </div>

      <div class="otp-container pt-3 pb-3">
        <input
          v-for="(digit, index) in otpDigits"
          :key="index"
          :ref="`otpInput${index}`"
          v-model="otpDigits[index]"
          type="text"
          maxlength="1"
          class="otp-digit-input"
          @input="handleOtpInput(index, $event)"
          @keydown="handleOtpKeydown(index, $event)"
          @paste="handleOtpPaste($event)"
        />
      </div>

      <div class="form-group pb-5">
        <div class="row">
          <div class="btn-group col-md-12 mt-3">
            <button @click="verifyOtp" :disabled="disableOtpButton" class="btn btn-primary">Verificar Código</button>
          </div>
        </div>
        <div class="row">
          <div class="btn-group col-md-12 mt-3">
            <button @click="resendOtp" class="btn btn-outline">Reenviar código</button>
          </div>
        </div>
        <div class="row">
          <div class="btn-group col-md-12 mt-2">
            <button @click="backToLogin" class="btn btn-link">Voltar</button>
          </div>
        </div>
      </div>
    </template>

    <p class="recaptcha-disclaimer">
      Este site é protegido pelo reCAPTCHA e se aplicam a
      <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Política de Privacidade</a>
      e os
      <a href="https://policies.google.com/terms" target="_blank" rel="noopener">Termos de Serviço</a>
      do Google.
    </p>
  </Form>
</template>

<script>
  import { UserIcon, LockIcon, EyeIcon, EyeOffIcon } from 'vue-feather-icons'
  import Form from '@/components/auth/Form'
  import GetUser from '@/mixins/GetUser'

  export default {
    components: { EyeIcon, EyeOffIcon, Form, LockIcon, UserIcon },
    computed: {
      disableLoginButton() {
        let inputEmail = this.$refs.email
        if (this.email && this.password && inputEmail)
          return !inputEmail.checkValidity()
        else
          return true
      },
      disableOtpButton() {
        return this.otpDigits.some(digit => digit === '')
      },
      otpCode() {
        return this.otpDigits.join('')
      }
    },
    created() {
      if (this.hasUser) this.$router.push('/');
    },
    data() {
      return {
        email: '',
        password: '',
        showPassword: false,
        otpRequested: false,
        otpDigits: ['', '', '', '', '', ''],
      };
    },
    methods: {
      async login() {
        const lastAccountId = this.$ls.get('last_account_id', { withoutKey: true })

        const data = {
          email: this.email,
          password: this.password,
        }

        if (lastAccountId)
          data.user = { account_id: lastAccountId }

        try {
          await this.$recaptcha('login')
        } catch (err) {
          this.$notify.add('Falha na verificação de segurança. Tente novamente.', { type: 'error' })
          return
        }

        this.axios.post('auth/sign_in', data)
          .then((resp) => {
            if (resp.data && resp.data.id) {
              this.setUser(resp.data)
              this.$router.push('/')
            } else if (resp.success) {
              this.otpRequested = true
              this.$notify.add(resp.data.message || 'Código de verificação enviado para seu email')
              this.$nextTick(() => {
                const firstInput = this.$refs.otpInput0
                if (firstInput && firstInput[0]) {
                  firstInput[0].focus()
                }
              })
            }
          })
          .catch(e => this.$notify.addError(e))
      },
      async verifyOtp() {
        if (this.disableOtpButton) return

        const lastAccountId = this.$ls.get('last_account_id', { withoutKey: true })

        const data = {
          email: this.email,
          password: this.password,
          otp_code: this.otpCode,
        }

        if (lastAccountId)
          data.user = { account_id: lastAccountId }

        try {
          await this.$recaptcha('login')
        } catch (err) {
          this.$notify.add('Falha na verificação de segurança. Tente novamente.', { type: 'error' })
          return
        }

        this.axios.post('auth/sign_in', data)
          .then((resp) => {
            this.setUser(resp.data)
            this.$router.push('/')
          })
          .catch(e => {
            this.$notify.addError(e)
            this.backToLogin()
          })
      },
      resendOtp() {
        this.clearOtpDigits()
        this.otpRequested = false
        this.$nextTick(() => {
          this.login()
        })
      },
      backToLogin() {
        this.otpRequested = false
        this.clearOtpDigits()
      },
      clearOtpDigits() {
        this.otpDigits = ['', '', '', '', '', '']
      },
      handleOtpInput(index, event) {
        const value = event.target.value

        if (!/^\d*$/.test(value)) {
          this.otpDigits[index] = ''
          return
        }

        this.$set(this.otpDigits, index, value)

        if (value && index < 5) {
          const nextInput = this.$refs[`otpInput${index + 1}`]
          if (nextInput && nextInput[0]) {
            nextInput[0].focus()
          }
        }
      },
      handleOtpKeydown(index, event) {
        if (event.key === 'Backspace' && !this.otpDigits[index] && index > 0) {
          const prevInput = this.$refs[`otpInput${index - 1}`]
          if (prevInput && prevInput[0]) {
            prevInput[0].focus()
          }
        }

        if (event.key === 'Enter' && !this.disableOtpButton) {
          this.verifyOtp()
        }
      },
      handleOtpPaste(event) {
        event.preventDefault()
        const pastedData = event.clipboardData.getData('text').trim()

        if (/^\d{6}$/.test(pastedData)) {
          const digits = pastedData.split('')
          digits.forEach((digit, index) => {
            this.$set(this.otpDigits, index, digit)
          })

          const lastInput = this.$refs.otpInput5
          if (lastInput && lastInput[0]) {
            lastInput[0].focus()
          }
        }
      },
      sendForgetPassword() {
        this.$router.push('/forgot_password')
      }
    },
    mixins: [GetUser],
    name: 'Login',
  }
</script>

<style scoped>

  .forgot-password {
    text-decoration-line: underline;
    color: var(--terciary-text-color);
    opacity: 0.8;
  }

  .eye-password {
    position: absolute;
    top: 8px;
    right: 13px;
    cursor: pointer;
    z-index: 5;
  }

  .btn-outline{
    min-height: 40px;
  }

  .otp-container {
    display: flex;
    justify-content: center;
    gap: 8px;
    padding: 0 20px;
  }

  .otp-digit-input {
    width: 45px;
    height: 50px;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
    border: 2px solid var(--input-border);
    border-radius: 8px;
    background-color: var(--input-bg);
    color: var(--input-text-color);
    transition: all 0.2s ease;
  }

  .otp-digit-input:focus {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 0.2rem rgba(45, 152, 218, 0.25);
  }

  .otp-digit-input:hover {
    border-color: var(--primary-color);
  }

  .text-muted {
    color: var(--terciary-text-color);
    opacity: 0.7;
  }

  .recaptcha-disclaimer {
    margin-top: 16px;
    margin-bottom: 0;
    text-align: center;
    font-size: 10px;
    line-height: 1.4;
    color: var(--terciary-text-color);
    opacity: 0.55;
  }

  .recaptcha-disclaimer a {
    color: inherit;
    text-decoration: underline;
  }

  @media (max-width: 576px) {
    .otp-container {
      gap: 6px;
      padding: 0 10px;
    }

    .otp-digit-input {
      width: 40px;
      height: 45px;
      font-size: 1.3rem;
    }
  }
</style>
